export default __webpack_public_path__ + "static/media/climate.f66176da.jpg";